<template>
    <div>
        <div class="loginInput"><b-form-input v-model="user" placeholder="Użytkownik" v-on:change="captchaRun"></b-form-input></div>
        <div class="loginInput"><b-form-input type="password" v-model="password" placeholder="Hasło"></b-form-input></div>
        <p v-if="badLogMessage">Niepoprawny login lub hasło</p>
        <div><b-button class="nrButton" v-on:click="userCheck">ZALOGUJ</b-button></div>
        <vue-recaptcha
        :loadRecaptchaScript="true"
        ref="recaptcha"
        @verify="onVerify"
        size="invisible"
        :sitekey="key">
      </vue-recaptcha>
    </div>
</template>

<script>
import axios from 'axios';
import {path} from '../../config';
import VueRecaptcha from 'vue-recaptcha';
import crypto from 'crypto';
export default {
    name: 'Login',
    components: {
        VueRecaptcha
    },
    methods: {
        userCheck: async function(){
            let hash = crypto.createHash('sha1');
            let data = hash.update(this.password, 'utf-8');
            let gen_hash = data.digest('hex');
            let payload = {
                user: this.user,
                password: gen_hash,
            }
            if(this.notBot === false){
                axios
                .post(`${path}login`, payload)
                .then(response => (
                        this.status = response.data,
                        this.$emit('setLogin', this.user, this.password, this.status.isAdmin, this.status.name, this.status._id),
                        this.badLogMessage = false
                    ))
                .catch(e => (
                    console.log(e),
                    this.badLogMessage = true
                ))
            }
        },
        async captchaRun() {
            this.$refs.recaptcha.execute();
            
        },
        onVerify: async function (response) {
            this.reCaptchaToken = response;
            let payload = {
                token: this.reCaptchaToken,
            }
            await axios
            .post(`${path}captcha`, payload)
            .then(response => (
                response.data.success && response.data.score > 0.5 ? this.notBot = false : this.notBot = true
            ))
            .catch(e => (
                console.log(e)
            ))
        },
        
    },
    data: function(){
        return{
            user: '',
            password: '',
            status: '',
            badLogMessage: false,
            // key: '6LdIZMYcAAAAABnXZNnJ6D8jfA9tY3ipUU15z0-x',
            key: '6Lex8MkcAAAAADpOkw_Dg-r2OVMkoqBM0KhynIs_',
            notBot: true,
            reCaptchaToken: '',
        }
    }
}
</script>

<style lang="scss" scoped>
.loginInput {
    width: 90%;
        margin: 10px auto;
        border: solid;
        border-width: 3px;
        border-radius: 10px;
        display: flex;
        flex-wrap: nowrap;
        input {
            text-align: center;
            font-size: 20px;
            height: 30px;
            flex: 5 0 0;
            border-radius: 7px;
        }
}
.nrButton {
        height: 50px;
        width: 90%;
        font-size: 20px;
        background-color: green;
        border-radius: 10px;
        border: none;
        margin: 10px auto;
        &:hover{
            background-color: rgb(101, 168, 0);
        }
        &:focus{
            background-color: green;
            border: none;
            box-shadow: none;
        }
    }
</style>